import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { UploadCatalogHelper } from '../../ecs/components';
import { Button, Card } from '@salesforce/design-system-react';
import { Desert } from './images/illustrations/no-data';

import './DashboardNoData.scss';

class DashboardNoData extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
  }

  uploadStarted() {
    this.props.history.replace('/catalogs');
  }

  skipUpload() {
    localStorage.setItem('userSkippedUpload', 'true');
    this.props.history.replace('/root/distribution');
  }

  renderNoData() {
    const { formatMessage } = this.props.intl;
    const helpLink =
      'https://help.salesforce.com/articleView?id=mc_pb_einstein_content_selection.htm&type=5';
    return (
      <div className="dashboard-no-data-container">
        <Desert />
        <div className="slds-text-longform">
          <h1 className="slds-text-heading_medium">
            <FormattedMessage id="components.ecs.nocatalog.header" />
          </h1>
          <p className="slds-text-heading_xsmall">
            <FormattedMessage
              id="components.ecs.nocatalog.description"
              values={{
                link: (
                  <a rel="noopener noreferrer" target="_blank" href={helpLink}>
                    {formatMessage({
                      id: 'components.ecs.nocatalog.helpLinkText'
                    })}
                  </a>
                )
              }}
            />
          </p>
          <Button
            id="upload-button"
            label={formatMessage({ id: 'components.ecs.nocatalog.import' })}
            variant="brand"
            onClick={() => this.fileInputRef.current.click()}
          />
          <Button
            id="skip-button"
            label={formatMessage({ id: 'components.ecs.nocatalog.skip' })}
            variant="brand"
            onClick={() => this.skipUpload()}
          />
          <UploadCatalogHelper
            actions={this.props.actions}
            _ref={this.fileInputRef}
            catalogs={this.props.catalogs?.data?.catalogs || []}
            onUploadStart={this.uploadStarted.bind(this)}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <Card
        heading=""
        className="dashboard-card dashboard-no-data"
        {...this.props}
      >
        <div className="asset-catalog">{this.renderNoData()}</div>
      </Card>
    );
  }
}

DashboardNoData.propTypes = {
  actions: PropTypes.shape({
    openModal: PropTypes.func
  }),
  catalogs: PropTypes.object,
  intl: intlShape.isRequired,
  history: PropTypes.object,
  modals: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(DashboardNoData);
